import { render, staticRenderFns } from "./DocumentRename.vue?vue&type=template&id=65cab9ca&"
import script from "./DocumentRename.vue?vue&type=script&lang=js&"
export * from "./DocumentRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports